import EnumState from "./gen/qsign/types/EnumState";
import SignRequestDocumentVO from "./gen/qsign/types/SignRequestDocumentVO";

/**
 * Seznam všech hodnot.
 */
export const values = [
  EnumState.INIT,
  EnumState.STORNO,
  EnumState.SIGN_IN_PROGRESS,
  EnumState.ERROR_SEALING,
  EnumState.SIGNED,
  EnumState.APPROVED,
  EnumState.REJECTED,
  EnumState.ERROR,
];
const labels = {
  [EnumState.ERROR]: "Chyba",
  [EnumState.ERROR_SEALING]: "Chyba při pečetění",
  [EnumState.INIT]: "Nevyřízený",
  [EnumState.REJECTED]: "Odmítnut",
  [EnumState.SIGNED]: "Podepsán",
  [EnumState.APPROVED]: "Schválen",
  [EnumState.SIGN_IN_PROGRESS]: "V průběhu podepisování",
  [EnumState.STORNO]: "Stornován",
};
const icons = {
  [EnumState.ERROR]: "exclamation-triangle",
  [EnumState.ERROR_SEALING]: "exclamation-triangle",
  [EnumState.INIT]: "hourglass-half",
  [EnumState.REJECTED]: "times",
  [EnumState.SIGNED]: "check",
  [EnumState.APPROVED]: "check",
  [EnumState.SIGN_IN_PROGRESS]: "hourglass-half",
  [EnumState.STORNO]: "times",
};
const colors = {
  [EnumState.ERROR]: "#EB5757",
  [EnumState.ERROR_SEALING]: "#EB5757",
  [EnumState.INIT]: "#007c90",
  [EnumState.REJECTED]: "#EB5757",
  [EnumState.SIGNED]: "#219653",
  [EnumState.APPROVED]: "#219653",
  [EnumState.SIGN_IN_PROGRESS]: "#4F4F4F",
  [EnumState.STORNO]: "#EB5757",
};
export function getCaption(source: EnumState) {
  const caption = labels[source];
  return caption ? caption : "[" + source + "]";
}
export function getStateCaption(item: SignRequestDocumentVO) {
  const source = item.state;
  const caption = labels[source];

  if (caption) {
    switch (source) {
      case EnumState.REJECTED:
        return caption + ": " + item.rejectReason;
      case EnumState.ERROR:
            return caption + ": " + item.errorMessage;
      default:
        return caption;
    }
  } else {
    return "[" + source + "]";
  }
}
export function getIcon(source: EnumState) {
  const icon = icons[source];
  return icon ? icon : null;
}
export function getColor(source: EnumState) {
  const color = colors[source];
  return color ? color : null;
}
